interface INote {
  id: string;
  title: string;
  content: string;
  created_time: string;
  created_by: string;
  created_by_name: string;
}

export function transformToBackendNote(data: INote) {
  return {
    id: data.id,
    title: data.title,
    content: data.content
  };
}

export function transformFromBackendNote(backendType: INote[]) {
  return backendType.map(note => ({
    id: note.id,
    title: note.title,
    content: note.content,
    createdAt: note.created_time,
    createdBy: note.created_by,
    createdByName: note.created_by_name
  }));
}
